import styled, { StyledComponent } from '@emotion/styled';
import { HeightSize, InputSize } from '~/constants/form';
import * as React from 'react';
import { colors, fontFamily } from '~/styles/constants';

interface ButtonProps {
  hasOptionSelected: boolean;
  size?: number;
  disabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (val: any) => void;
  type: string;
  responsive?: boolean;
  className?: string;
  tabIndex?: number;
  isMultiSelect?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: (node: any) => void;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
const SelectButtonStyled: StyledComponent<{}, ButtonProps, {}> = styled('button')<any>`
  background: transparent;
  border: none;
  font-family: ${fontFamily};
  ${(props) => (props.responsive ? 'width: 100%;' : `width: ${props.size}px;`)};
  text-align: left;
  font-size: 14px;
  color: ${(props) => (props.hasOptionSelected ? colors.gray600 : colors.placeholderColor)};
  position: relative;
  outline: none;
  text-decoration: underline;
  cursor: pointer;
  line-height: 19px;
  display: inline-block;

  :focus,
  &:active {
    border-color: ${colors.primaryAlternative};
  }

  :disabled {
    background-color: ${colors.form.greyDisabled};
    border-color: ${colors.form.greyDisabledBorder};
  }
`;

const StyledIcon = styled('i')`
  margin-left: 4px;
  font-size: 12px;
  color: ${colors.placeholderColor};
`;

interface SelectButtonProps {
  disabled?: boolean;
  text?: string;
  onClick(evt: React.MouseEvent): void;
  hasOptionSelected?: boolean;
  size?: InputSize;
  responsive?: boolean;
  className?: string;
  tabIndex?: number;
  invalid?: boolean;
  isMultiSelect?: boolean;
  height?: HeightSize;
  dataAnalytics?: string;
  dataPendo?: string;
  dataE2E?: string;
  dataTestid?: string;
  buttonRef?: (node: React.ReactNode) => void;
  children?: React.ReactNode;
}

const SelectButton = (props: SelectButtonProps) => {
  const {
    children,
    disabled,
    onClick,
    hasOptionSelected,
    size,
    responsive,
    className,
    tabIndex,
    isMultiSelect,
    dataAnalytics,
    dataPendo,
    dataE2E,
    dataTestid,
    buttonRef,
  } = props;

  const linkSize = size ? size : InputSize.medium;

  return (
    <SelectButtonStyled
      disabled={!!disabled}
      onClick={onClick}
      hasOptionSelected={!!hasOptionSelected}
      size={linkSize}
      type="button"
      responsive={responsive}
      className={className}
      tabIndex={tabIndex}
      isMultiSelect={isMultiSelect}
      data-analytics={dataAnalytics}
      data-pendo={dataPendo}
      data-e2e={dataE2E}
      data-testid={dataTestid}
      ref={buttonRef}
    >
      {children}
      <StyledIcon className="fa fa-chevron-down" />
    </SelectButtonStyled>
  );
};

export default SelectButton;
